/**********************************************************/
/*  @name       VICTORY digital                           */
/*	@copyright	VICTORY group                             */
/*	@support	https://victoryagency.ru/digital          */
/**********************************************************/

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/parallax";
import "swiper/css/thumbs";
import "../../scss/styles.scss";

import {
  lightbox,
  initUtils,
  getRem,
  declOfNum,
  moveElementsOnMobile,
} from "./modules/utlis.js";
import { initInputs } from "./modules/inputs.js";
import { headerNavigation } from "./modules/nav.js";
import { initSections } from "./modules/sections.js";
import { initSliders } from "./modules/sliders.js";
import { initCookieConsent } from "./lib/cookie-consent.js";
import { initVGMap } from "./lib/victorymap.js";

headerNavigation();

document.addEventListener("DOMContentLoaded", () => {
  // initVGMap();
  initSections();
  initUtils();
  initInputs();
  initSliders();
  moveElementsOnMobile();
  // initCookieConsent({
  //   type: "mixed",
  //   theme: "dark",
  // });
});

window.addEventListener("resize", () => {
  moveElementsOnMobile();
});
